import styled from 'styled-components'
import bgIllustrator from '../assets/images/bg-illustrator.png'

const Page = styled.div`
   display: flex;
   min-height: 100vh;
   background: #fff;
   font-family: 'Geist', system-ui, sans-serif;

   @media (max-width: 900px) {
      flex-direction: column;
      min-height: 100dvh; /* mobile dynamic viewport */
   }
`;

const Left = styled.div`
   flex: 1;
   min-width: 50%;
   display: flex;
   flex-direction: column;
   padding: 48px 56px 56px 56px;

   @media (max-width: 900px) {
      padding: 32px 24px 40px 24px;
      flex: none;
      width: 100%;
   }
`;

const Logo = styled.img`
   width: 132px;
   height: auto;
`;

const FormWrap = styled.div`
   margin: auto 0;
   display: flex;
   justify-content: center;
   align-items: center;

   @media (max-width: 900px) {
      margin-top: 56px;
      max-width: 100%;
      align-items: flex-start;
   }
`;

const FormContainer = styled.div`
   max-width: 420px;
   margin: auto;
`;

const Title = styled.h1`
   font-size: 23px;
   font-weight: 600;
   letter-spacing: -0.025em;
   color: #101018;
   margin: 0 0 12px;
`;

const Subtitle = styled.p`
   font-size: 14px;
   line-height: 1.5;
   color: #858589;
   margin: 0 0 40px;
`;

const Label = styled.label`
   font-size: 14px;
   font-weight: 500;
   color: #6D6D72;
   letter-spacing: -0.025em;
   display: block;
   margin-bottom: 8px;
`;

const InputWrap = styled.div`
   position: relative;
`;

const Input = styled.input`
   width: 100%;
   background: #fff;
   border: 1px solid #E4E4E7;
   border-radius: 8px;
   padding: 12px 14px;
   font-size: 14px;
   outline: none;
   color: #101018;
   letter-spacing: -0.025em;
   transition: border .2s ease-in-out;

   &:focus {
      box-shadow: 0 0 0 3px rgba(139,92,246,0.25);
      border-color: #8B5CF6;
   }
   &::placeholder { color: #A1A1A5; }
`;

const PasswordToggle = styled.button`
   position: absolute;
   right: 10px;
   top: 50%;
   transform: translateY(-50%);
   background: none;
   border: none;
   cursor: pointer;
   padding: 4px;
   color: #6D6D72;
   display: flex;
   align-items: center;
`;

const Button = styled.button`
   width: 100%;
   margin-top: 32px;
   background: #B88AE6; /* gradient placeholder */
   background: linear-gradient(90deg, #AF7AD5,#ab69da);
   border: none;
   color: #fff;
   font-size: 14px;
   font-weight: 600;
   letter-spacing: -0.025em;
   padding: 14px 20px;
   border-radius: 24px;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   gap: 6px;
   cursor: pointer;
   transition: box-shadow .2s, transform .15s;
   position: relative;
   overflow: hidden;
   &:hover { box-shadow: 0 4px 14px -2px rgba(139,92,246,0.35); }
   &:active { transform: translateY(2px); }
`;

const Right = styled.div`
   flex: 1;
   min-width: 50%;
   position: relative;
   display: flex;
   align-items: flex-end;
   justify-content: flex-end;
   background: #F6F6F6;
   background-image: url(${bgIllustrator});
   background-repeat: repeat;
   background-position: center;
   background-size: contain;

   @media (max-width: 900px) {
      flex: none;
      width: 100%;
      height: 300px;
      align-items: center;
      justify-content: center;
      background: #F7F7F9;
      margin-top: 32px;
   }
`;

const HeroMock = styled.img`
   width: 80%;
   max-width: 100%;
   position: absolute;
   object-fit: contain;
   pointer-events: none;
   --webkit-user-drag: none;
   --webkit-pointer-events: none;

   @media (max-width: 900px) {
      position: relative;
      bottom: auto;
      right: auto;
      margin-top: 30px;
      width: min(100%,480px);
   }
`;


export {
   Page,
   Left,
   Logo,
   FormWrap,
   FormContainer,
   Title,
   Subtitle,
   Label,
   InputWrap,
   Input,
   PasswordToggle,
   Button,
   Right,
   HeroMock
}